module.exports = __webpack_public_path__ + "assets/images/project/constituencies/punggol-west-smc.jpg?v=8757536e";